/** Shared helpers for client portal pages. */

export function inr(n) {
  if (n == null || isNaN(n)) return "₹0";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
}

export function inrShort(n) {
  if (n == null || isNaN(n)) return "₹0";
  const abs = Math.abs(n);
  if (abs >= 1e7) return `₹${(n / 1e7).toFixed(2)}Cr`;
  if (abs >= 1e5) return `₹${(n / 1e5).toFixed(2)}L`;
  if (abs >= 1e3) return `₹${(n / 1e3).toFixed(1)}K`;
  return `₹${Math.round(n)}`;
}

export function fmtDate(value) {
  if (!value) return "—";
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return value;
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${m[3]} ${months[parseInt(m[2], 10) - 1]} ${m[1]}`;
}

export function fmtDateTime(value) {
  if (!value) return "—";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    const date = fmtDate(d.toISOString());
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${date}, ${hh}:${mm}`;
  } catch {
    return value;
  }
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="border-b border-slate-200 bg-white">
      <div className="px-4 sm:px-8 py-5 sm:py-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div className="min-w-0">
          {subtitle && <div className="text-[10px] tracking-[0.18em] uppercase text-slate-500 mb-1">{subtitle}</div>}
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight break-words" style={{ fontFamily: "Outfit" }} data-testid="cp-page-title">{title}</h1>
        </div>
        {action && <div className="shrink-0 flex items-center gap-2 flex-wrap">{action}</div>}
      </div>
    </div>
  );
}

export function KpiCard({ label, value, hint, accent, testid }) {
  const accents = {
    blue: "border-l-4 border-l-[#0a2540]",
    green: "border-l-4 border-l-emerald-600",
    amber: "border-l-4 border-l-amber-500",
    red: "border-l-4 border-l-red-600",
  };
  return (
    <div className={`bg-white border border-slate-200 ${accents[accent || "blue"]} p-5 rounded-sm`} data-testid={testid}>
      <div className="text-[10px] tracking-[0.18em] uppercase text-slate-500">{label}</div>
      <div className="text-2xl font-bold mt-1 tracking-tight" style={{ fontFamily: "Outfit" }}>{value}</div>
      {hint && <div className="text-[11px] text-slate-500 mt-1">{hint}</div>}
    </div>
  );
}

export function StatusPill({ status }) {
  const s = (status || "").toLowerCase();
  let cls = "bg-slate-100 text-slate-700";
  if (s === "paid" || s === "done" || s === "closed") cls = "bg-emerald-100 text-emerald-800";
  else if (s === "pending" || s === "upcoming" || s === "open") cls = "bg-blue-100 text-blue-800";
  else if (s === "partial" || s === "responded") cls = "bg-amber-100 text-amber-800";
  else if (s === "overdue") cls = "bg-red-100 text-red-800";
  return <span className={`inline-block px-2 py-0.5 text-[10px] tracking-wide rounded-sm uppercase font-semibold ${cls}`}>{status || "—"}</span>;
}
